export default __webpack_public_path__ + "static/1057-a88732e6d942a713593b6b90fc0a1675.gif";